import React from 'react';
import { GSC_VERIFICATION, BING_VERIFICATION } from '../seo/operationalConfig';

// WP-3.1 — sitewide search-engine verification metas (render-time, React-19-native
// hoist; same mechanism as Seo.jsx).
//
// DARK / fail-closed: emits a tag ONLY when its token env is set; emits nothing by
// default. These are DISTINCT <meta name> tags (not title / description / canonical
// / OpenGraph) → ADR-0007-safe (they do not form a second metadata set and cannot
// collide with the per-route metadata). The WP-2 reconciliation strip (index.js)
// removes the prerendered copies before re-mount, so activation never duplicates them.
export default function SiteVerification() {
  return (
    <>
      {GSC_VERIFICATION ? (
        <meta name="google-site-verification" content={GSC_VERIFICATION} />
      ) : null}
      {BING_VERIFICATION ? <meta name="msvalidate.01" content={BING_VERIFICATION} /> : null}
    </>
  );
}
